import { useEffect, useRef, useState } from "react";

/**
 * Tiny IntersectionObserver hook for scroll-reveal effects.
 * Returns [ref, isVisible].
 */
export function useReveal(options = { threshold: 0.15, once: true }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          if (options.once) io.unobserve(node);
        } else if (!options.once) {
          setVisible(false);
        }
      },
      { threshold: options.threshold || 0.15 }
    );
    io.observe(node);
    return () => io.disconnect();
  }, [options.once, options.threshold]);

  return [ref, visible];
}

export function Reveal({ children, className = "", delay = 0, as: Tag = "div" }) {
  const [ref, visible] = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? "in" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </Tag>
  );
}
